import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { EntityType } from '../../../entity.types';
import { HideWrapper } from '../../HideWrapper';
import { EntityInfos } from '../../../expertises/infos/EntityInfos';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../../../components/EntityBlockComponents';
import { EntityChartContainer } from '../../components/EntityChartComponents';

type Props = {
  decisionCount: number;
  entityType: EntityType;
  entityId: string;
  entityName: string;
};

export const CompanySectorTypologiesPresentation: FC<Props> = ({
  decisionCount,
  entityType,
  entityId,
  entityName,
  children,
}) => {
  return (
    <HideWrapper source="company_sector_typologies_chart">
      <EntityBlock>
        <EntityBlockTitle>
          <FormattedMessage id="entity/charts/typologies/sectors/CompanySectorTypologiesPresentation.tsx/1" />
        </EntityBlockTitle>
        <EntityInfos
          decisionCount={decisionCount}
          entityType={entityType}
          lawyerId={entityId}
          entityName={entityName}
        />
        <EntityChartContainer>{children}</EntityChartContainer>
      </EntityBlock>
    </HideWrapper>
  );
};
